import { z } from 'zod';

import { levelEnumValidator } from '../../validators';
import { PaginationQuerySchema } from '../pagination';

export const WordsQueryPaginationSchema = PaginationQuerySchema.extend({
  isShared: z
    .preprocess((val) => {
      if (val === 'true') return true;
      if (val === 'false') return false;
      return undefined;
    }, z.boolean().optional())
    .describe(
      'Filter words by shared status. `true` for shared only, `false` for personal only, omit for both.',
    ),
  levels: z
    .preprocess((val) => {
      if (typeof val === 'string' && val.length > 0) {
        return val.split(',');
      }
      return Array.isArray(val) ? val : undefined;
    }, z.array(levelEnumValidator).optional())
    .describe('Filter words by an array of CEFR levels (e.g., A1,A2).'),
});

export type IWordsQueryPaginationDto = z.infer<
  typeof WordsQueryPaginationSchema
>;

export const SearchWordsQuerySchema = WordsQueryPaginationSchema.extend({
  text: z.string().optional(),
});

export type ISearchWordsQueryDto = z.infer<typeof SearchWordsQuerySchema>;
